import { useEffect, useState } from 'react';
import Header from '../Header/Header';
import WeatherIcon from '../WeatherIcon/WeatherIcon';
import { getWeatherIconByLevel } from '../../utils/constants';
import { WeatherInfoContainer } from './WeatherInfo.styles';

const formatTime = (timeStr) => {
    let hour = parseInt(timeStr.substring(0, 2));
    let minute = parseInt(timeStr.substring(2, 4));
    let minuteStr = minute === 0 ? "" : ":" + minute;
    if (hour > 12) return (hour - 12) + minuteStr + " PM";
    return hour + minuteStr + " AM";
};

const WeatherInfo = () => {
    const [state, setState] = useState({});
    const [datetime, setDatetime] = useState("");

    useEffect(() => {
        window.gtag("event", "Page_리포트");

        let item = JSON.parse(localStorage.getItem("_mwInfo"));
        item.weatherIcon = getWeatherIconByLevel(item.conditionLv);
        item.startTime = formatTime(item.startTime);
        item.destTime = formatTime(item.destTime);
        item.isLoad = true;
        setState(item);

        let dt = item.date.substring(0, 4) + "-"
            + item.date.substring(4, 6) + "-"
            + item.date.substring(6, 8) + " "
            + item.time.substring(0, 2) + ":"
            + item.time.substring(2, 4) + " 기준";
        setDatetime(dt);
    }, []);

    return (
        <WeatherInfoContainer>
            <Header />
            <label className='scdFont titleLb'>날씨</label><br />
            <label className='timeLb'>{state.startTime} ~ {state.destTime}</label>

            <div className='weatherCard'>
                <div className='weatherIconWrap'>
                    {state.weatherIcon &&
                        <WeatherIcon name={state.weatherIcon} size={60} />
                    }
                </div>
                <div className='weatherStats'>
                    <div className='tempLb'>
                        {state.minTemp}<label className='topTxt'>o</label> ~ {state.maxTemp}<label className='topTxt'>o</label>
                    </div>
                    <div className='rainRateLb'>
                        {state.rainRate}<label className='topTxt'>%</label>
                    </div>
                </div>
            </div>

            <div className={'weatherInfoLb ' + (!state.isLoad ? 'hide' : '')}>
                {state.isRain
                    ? <>
                        오늘 일정에 비(눈)이/가 예보되어 있습니다. 우산을 챙기세요.
                        {state.isShower ? <> 소나기를 주의하세요.</> : null}<br />
                    </>
                    : null
                }
                {state.minTemp
                    ? <>최저 기온은 {state.minTemp}도 이며 최고 기온은 {state.maxTemp}도 입니다.<br /></>
                    : null
                }
                {state.windChill && state.windChill < 0
                    ? <>체감 온도가 {state.windChill}도까지 떨어집니다. 두꺼운 겉옷을 준비해주세요.<br /></>
                    : null
                }
                습도는 {state.humidity}%입니다.<br />
                {state.humidity && state.humidity <= 40
                    ? <>습도가 낮습니다. 가습을 해주시고 물을 많이 마셔주세요.<br /></>
                    : null
                }
                풍속은 {state.windSpeed}m/s입니다.<br />
                {state.windSpeed && state.windSpeed > 5
                    ? <>강한 바람이 예상됩니다.<br /></>
                    : null
                }
                {state.maxTemp && state.humidity &&
                    (0.81 * state.maxTemp + 0.01 * state.humidity * (0.99 * state.maxTemp - 14.3) + 46.3) >= 75
                    ? <>불쾌지수가 높습니다. 더위에 유의하세요.<br /></>
                    : null
                }
            </div>
            <label className='about'>{datetime}</label>
        </WeatherInfoContainer>
    );
};

export default WeatherInfo;
